
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.005 28.441a2.034 2.034 0 00-2.03-2.16h-2.63c2.19-2.85.48-6.81-.95-10.12-.49-1.14-1-2.32-1.37-3.43-.01-.03-.03-.05-.04-.08-.02-.05-.05-.09-.07-.14a.951.951 0 00-.15-.2c-.02-.02-.04-.04-.06-.05-.23-.2-.53-.31-.84-.24-.5.11-.84.54-.78 1.04-.11.88-3.4 6.23-9.36 5.79-4.89-.36-8.88 2.45-10.54 5.21-.47.78-.73 1.53-.78 2.21h-1.37c-.56 0-1.1.24-1.49.65-.38.41-.58.96-.54 1.51.42 6.12 4.21 11.29 9.46 13.78v3.06c0 1.02.83 1.84 1.84 1.84h10.39c1.02 0 1.84-.83 1.84-1.84v-3.06c5.26-2.48 9.05-7.65 9.47-13.77zm-27.11-3.33c1.36-2.25 4.66-4.53 8.68-4.25 4.56.34 7.68-2.17 9.14-3.69.27-.28.54-.6.8-.93.16 1.58.1 3.37-.94 4.66-1.03 1.29-2.96 2.01-5.73 2.16-.55.03-.97.5-.95 1.05.03.53.47.95 1 .95h.05c3.36-.18 5.77-1.16 7.18-2.91.75-.93 1.14-1.99 1.32-3.06 1.32 3.38 1.59 5.67-1.22 7.18h-19.81c.05-.27.18-.66.48-1.16zm15.65 20.01h-10.07v-2.11c1.59.51 3.28.8 5.04.8 1.76 0 3.44-.29 5.04-.8v2.11h-.01zm-5.04-3.3c-6.08 0-11.36-3.8-13.49-9.21h21.76c.55 0 1-.45 1-1s-.45-1-1-1h-22.38c-.18-.76-.31-1.53-.36-2.33l28.98.02c-.53 7.58-6.9 13.52-14.51 13.52z"}})])
          )
        }
      }
    